<ion-content class="container">
  <div class="tabs-container">
    <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb">
      <img (click)="onClickBreadcrumExpence()" src="././assets/icon/backArrow.svg" class="cp">
      <label class="font_semibold fs-18 ml-10 mt-5 black_color">
        <span class="cp" (click)="onClickBreadcrumExpence()">Expense</span> /
        <span [style.color]="buttonColorName">Logs</span>
      </label>
    </div>
    <div class="card">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size-sm="10" size-md="7" size-lg="7" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)">
              <mat-tab label="Deleted Reimbursement">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      delete
                    </span>Deleted Reimbursement</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Updated Reimbursement">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      update
                    </span>Updated Reimbursement</span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ion-col>
      
      </ion-row>
    </div>
    
    <div class="card  employeeTab">
      <ion-row class="ion-align-items-center">
        <!-- Year Dropdown (left side) -->
        <ion-col size="12" size-md="3" class="mt-10">
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select 
              placeholder="Select" 
              [(ngModel)]="selectedYearForCompetency"
              (selectionChange)="viewReimbursementByYear($event.value)">
              <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                {{ sharedService.transformYearToFyFormat(item.year) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ion-col>
      
        <!-- Refresh Icon (right side) -->
        <ion-col size="12" size-md="9" class="ion-text-right mt-10">
          <span 
            class="ml-5 fs-20 material-icons btn-reset"
            style="cursor:pointer;"
            [class.clicked]="isClicked"
            (click)="resetGrid(); isClicked = true"
            (animationend)="isClicked = false">
            refresh
          </span>
        </ion-col>
      </ion-row>
      
      <div class="p-10 m-20" *ngIf="selectedTypeTabName=='Updated Reimbursement'">
        <mat-sidenav-container style="height: 100%;">
          <!-- Main Content with AG Grid -->
          <mat-sidenav-content>
            <ag-grid-angular
              style="width: 100%; height: 600px;"
              class="ag-theme-quartz"
              [rowData]="updateLogsData"
              [columnDefs]="taskColumnHeaderInfo"
              [gridOptions]="gridOptions"
              [defaultColDef]="defaultColDef"
              (gridReady)="onGridReady($event)"
              (rowClicked)="onRowClicked($event)"
              [pagination]="pagination"
              [paginationPageSize]="paginationPageSize"
              [paginationPageSizeSelector]="paginationPageSizeSelector"
              [detailRowAutoHeight]="detailRowAutoHeight"
              [localeText]="{ noRowsToShow: 'No Data Found' }"
            >
            </ag-grid-angular>
          </mat-sidenav-content>
       
          <!-- Right Side Sidenav -->
          <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
            <!-- HEADER -->
            <div class="details-header">
              <h2>Reimbursement Details</h2>
              <button mat-icon-button (click)="closeDetails()">
                <mat-icon class="close-icon">close</mat-icon>
              </button>
            </div>
          
            <!-- CONTENT -->
            <div class="details-content" *ngIf="selectedRow">
              <mat-card class="detail-card" *ngFor="let col of taskColumnHeaderInfo">
                <mat-card-content>
                  <div class="detail-row">
                    <mat-icon class="detail-icon">trending_flat</mat-icon>
                    <div class="detail-text">
                      
                      <!-- LABEL -->
                      <span class="detail-label">{{ col.headerName }} </span>
          
                      <!-- STATUS BADGE -->
                      <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                        <span class="status-badge"
                              [ngClass]="{
                                'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                                'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                                'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                              }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>
          
                      <!-- APPROVAL BADGE -->
                      <ng-template #approvalCheck>
                        <ng-container *ngIf="col.headerName === 'Approval'; else normalContent">
                          <span class="status-badge"
                                [ngClass]="{
                                  'approved': selectedRow[col.field] === 'APPROVED',
                                  'rejected': selectedRow[col.field] === 'REJECTED',
                                  'pending': selectedRow[col.field] === 'PENDING'
                                }">
                            {{ formatStatus(selectedRow[col.field]) }}
                          </span>
                        </ng-container>
                      </ng-template>
          
                      <!-- NORMAL DATA / DOCUMENT -->
                      <ng-template #normalContent>
                        <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                          <ng-container *ngIf="selectedRow[col.field]; else noFile">
                            <img src="assets/icon/yellowdownload.png"
                                alt="download"
                                width="18" height="18"
                                style="cursor:pointer"
                                (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))"
                            />
                          </ng-container>
                          <ng-template #noFile>
                            <span></span>
                          </ng-template>
                        </ng-container>
          
                        <ng-template #textValue>
                          <span>
                            {{ (col.field === 'date' || col.field === 'dateOfExpense') 
                                ? formatDate(selectedRow[col.field]) 
                                : selectedRow[col.field] || selectedRow[col.field]}}
                          </span>
                        </ng-template>
                        
                      </ng-template>
          
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-sidenav>
        </mat-sidenav-container>
 
      </div>


        <div class="p-10 m-20" *ngIf="selectedTypeTabName=='Deleted Reimbursement'">
          <mat-sidenav-container style="height: 100%;">
            <!-- Main Content with AG Grid -->
            <mat-sidenav-content>
              <ag-grid-angular
                style="width: 100%; height: 600px;"
                class="ag-theme-quartz"
                [rowData]="deleteLogsData"
                [columnDefs]="taskDeletedHeaderInfo"
                [gridOptions]="gridOptions"
                [defaultColDef]="defaultColDef"
                (gridReady)="onGridReady($event)"
                (rowClicked)="onRowClicked($event)"
                [pagination]="pagination"
                [paginationPageSize]="paginationPageSize"
                [paginationPageSizeSelector]="paginationPageSizeSelector"
                [detailRowAutoHeight]="detailRowAutoHeight"
                [localeText]="{ noRowsToShow: 'No Data Found' }"
              >
              </ag-grid-angular>
            </mat-sidenav-content>
         
            <!-- Right Side Sidenav -->
            <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
              <!-- HEADER -->
              <div class="details-header">
                <h2>Reimbursement Details</h2>
                <button mat-icon-button (click)="closeDetails()">
                  <mat-icon class="close-icon">close</mat-icon>
                </button>
              </div>
            
              <!-- CONTENT -->
              <div class="details-content" *ngIf="selectedRow">
                <mat-card class="detail-card" *ngFor="let col of taskDeletedHeaderInfo">
                  <mat-card-content>
                    <div class="detail-row">
                      <mat-icon class="detail-icon">trending_flat</mat-icon>
                      <div class="detail-text">
                        
                        <!-- LABEL -->
                        <span class="detail-label">{{ col.headerName }} </span>
            
                        <!-- STATUS BADGE -->
                        <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                          <span class="status-badge"
                                [ngClass]="{
                                  'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                                  'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                                  'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                                }">
                            {{ formatStatus(selectedRow[col.field]) }}
                          </span>
                        </ng-container>
            
                        <!-- APPROVAL BADGE -->
                        <ng-template #approvalCheck>
                          <ng-container *ngIf="col.headerName === 'Approval'; else normalContent">
                            <span class="status-badge"
                                  [ngClass]="{
                                    'approved': selectedRow[col.field] === 'APPROVED',
                                    'rejected': selectedRow[col.field] === 'REJECTED',
                                    'pending': selectedRow[col.field] === 'PENDING'
                                  }">
                              {{ formatStatus(selectedRow[col.field]) }}
                            </span>
                          </ng-container>
                        </ng-template>
            
                        <!-- NORMAL DATA / DOCUMENT -->
                        <ng-template #normalContent>
                          <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                            <ng-container *ngIf="selectedRow[col.field]; else noFile">
                              <img src="assets/icon/yellowdownload.png"
                                  alt="download"
                                  width="18" height="18"
                                  style="cursor:pointer"
                                  (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))"
                              />
                            </ng-container>
                            <ng-template #noFile>
                              <span></span>
                            </ng-template>
                          </ng-container>
            
                          <ng-template #textValue>
                            <span>
                              {{ (col.field === 'date' || col.field === 'dateOfExpense') 
                                  ? formatDate(selectedRow[col.field]) 
                                  : selectedRow[col.field] || selectedRow[col.field]}}
                            </span>
                          </ng-template>
                          
                        </ng-template>
            
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </mat-sidenav>
          </mat-sidenav-container>
         
        </div>



    </div>

  </div>
  
</ion-content>